// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  type InfiniteData,
  infiniteQueryOptions,
  queryOptions,
  type UseMutationOptions,
  useQuery,
} from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { client } from "../client.gen";
import {
  authLogout,
  cancelPayment,
  cancelProject,
  completeWelcomeCall,
  confirmOtp,
  createAgreement,
  createConnectedAccount,
  createIdentityVerificationSetup,
  createInsight,
  createInvite,
  createMedia,
  createMfaRefreshSession,
  createPaymentMethod,
  createPlaidLinkToken,
  createProject,
  createProperty,
  createSignature,
  deleteConnectedAccount,
  deletePaymentMethod,
  exchangeSutForTokenV2,
  generateSutV2,
  getAchievements,
  getActiveQuote,
  getAuthStatus,
  getConnectedAccounts,
  getContractSignUrl,
  getConversations,
  getCreditApplicationUrl,
  getCurrentUser,
  getCurrentUserV3,
  getCurrentWeeklyEnergyBudget,
  getData,
  getDocument,
  getEstimatedProduction,
  getFeaturedManufacturers,
  getFinanceAccount,
  getFinanceAccountDocument,
  getFinanceAccountDocuments,
  getFinanceAccounts,
  getInsight,
  getInsights,
  getIntercomJwt,
  getLatestInsight,
  getLifetimeSavings,
  getManufacturers,
  getMe,
  getOtpOptions,
  getPaymentMethods,
  getPointTransactions,
  getProduct,
  getProductSavings,
  getProject,
  getProjectDisclosures,
  getProjectDocuments,
  getProjects,
  getProperty,
  getPropertyAlerts,
  getPropertyAlertsDailySeverity,
  getPropertyBatteryEnergyTotals,
  getPropertyEnergyMax,
  getPropertyTariffs,
  getPropertyUtilities,
  getPropertyWeather,
  getQuestionnaire,
  getQuestions,
  getQuizQuestions,
  getRatePlanEligibility,
  getRatePlanOptions,
  getSignupLink,
  getSimulatedProduction,
  getSystemDetails,
  getTasks,
  getTicket,
  getTickets,
  getUpgrades,
  getUser,
  getUserFeedback,
  getUserProperties,
  getWeeklyEnergyBudget,
  getWelcomeCallUrl,
  getWrapped2025,
  initiateEmailChange,
  login,
  markProjectViews,
  markWeeklyEnergyBudgetViewed,
  type Options,
  postCouponCode,
  postPayment,
  postQuest,
  postUserFeedback,
  putQuest,
  reopenConversation,
  restartEmailChangeVerification,
  searchByAssociatedEntity,
  searchFeedItems,
  searchProducts,
  searchSavings,
  sendOtp,
  sendOtp2,
  setDefaultPaymentMethod,
  signup,
  streamDocument,
  submitAnswer,
  submitCreditApplication,
  updateConnectedAccount,
  updateCredentials,
  updateFeedItemStatus,
  updateProjectFeedItemStatus,
  updateProperty,
  updatePropertyBuilding,
  uploadMedia,
  uploadProjectDocuments,
  validateAgreement,
  verifyEmailChange,
  verifyPlaidAccount,
  viewAchievement,
} from "../sdk.gen";
import type {
  AuthLogoutData,
  AuthLogoutResponse,
  CancelPaymentData,
  CancelPaymentResponse,
  CancelProjectData,
  CancelProjectResponse,
  CompleteWelcomeCallData,
  ConfirmOtpData,
  ConfirmOtpResponse2,
  CreateAgreementData,
  CreateConnectedAccountData,
  CreateConnectedAccountResponse,
  CreateIdentityVerificationSetupData,
  CreateIdentityVerificationSetupResponse,
  CreateInsightData,
  CreateInsightResponse,
  CreateInviteData,
  CreateMediaData,
  CreateMediaResponse2,
  CreateMfaRefreshSessionData,
  CreateMfaRefreshSessionResponse,
  CreatePaymentMethodData,
  CreatePaymentMethodResponse,
  CreatePlaidLinkTokenData,
  CreatePlaidLinkTokenResponse,
  CreateProjectData,
  CreatePropertyData,
  CreatePropertyResponse,
  CreateSignatureData,
  CreateSignatureResponse2,
  DeleteConnectedAccountData,
  DeleteConnectedAccountResponse,
  DeletePaymentMethodData,
  DeletePaymentMethodResponse,
  ExchangeSutForTokenV2Data,
  GenerateSutV2Data,
  GenerateSutV2Response,
  GetAchievementsData,
  GetAchievementsResponse,
  GetActiveQuoteData,
  GetActiveQuoteResponse,
  GetAuthStatusData,
  GetAuthStatusResponse,
  GetConnectedAccountsData,
  GetConnectedAccountsResponse,
  GetContractSignUrlData,
  GetContractSignUrlResponse,
  GetConversationsData,
  GetConversationsResponse,
  GetCreditApplicationUrlData,
  GetCreditApplicationUrlResponse,
  GetCurrentUserData,
  GetCurrentUserV3Data,
  GetCurrentUserV3Response,
  GetCurrentWeeklyEnergyBudgetData,
  GetDataData,
  GetDocumentData,
  GetDocumentResponse,
  GetEstimatedProductionData,
  GetEstimatedProductionResponse2,
  GetFeaturedManufacturersData,
  GetFeaturedManufacturersResponse,
  GetFinanceAccountData,
  GetFinanceAccountDocumentData,
  GetFinanceAccountDocumentsData,
  GetFinanceAccountDocumentsResponse,
  GetFinanceAccountResponse,
  GetFinanceAccountsData,
  GetFinanceAccountsResponse,
  GetInsightData,
  GetInsightResponse,
  GetInsightsData,
  GetInsightsResponse,
  GetIntercomJwtData,
  GetIntercomJwtResponse,
  GetLatestInsightData,
  GetLatestInsightResponse,
  GetLifetimeSavingsData,
  GetLifetimeSavingsResponse,
  GetManufacturersData,
  GetManufacturersResponse,
  GetMeData,
  GetOtpOptionsData,
  GetOtpOptionsResponse,
  GetPaymentMethodsData,
  GetPaymentMethodsResponse,
  GetPointTransactionsData,
  GetPointTransactionsResponse,
  GetProductData,
  GetProductResponse,
  GetProductSavingsData,
  GetProductSavingsResponse,
  GetProjectData,
  GetProjectDisclosuresData,
  GetProjectDisclosuresResponse2,
  GetProjectDocumentsData,
  GetProjectDocumentsResponse,
  GetProjectResponse,
  GetProjectsData,
  GetProjectsResponse,
  GetPropertyAlertsDailySeverityData,
  GetPropertyAlertsDailySeverityResponse,
  GetPropertyAlertsData,
  GetPropertyAlertsResponse,
  GetPropertyBatteryEnergyTotalsData,
  GetPropertyBatteryEnergyTotalsResponse,
  GetPropertyData,
  GetPropertyEnergyMaxData,
  GetPropertyEnergyMaxResponse,
  GetPropertyResponse,
  GetPropertyTariffsData,
  GetPropertyTariffsResponse2,
  GetPropertyUtilitiesData,
  GetPropertyUtilitiesResponse,
  GetPropertyWeatherData,
  GetPropertyWeatherResponse,
  GetQuestionnaireData,
  GetQuestionnaireResponse,
  GetQuestionsData,
  GetQuestionsResponse,
  GetQuizQuestionsData,
  GetQuizQuestionsResponse,
  GetRatePlanEligibilityData,
  GetRatePlanEligibilityResponse,
  GetRatePlanOptionsData,
  GetSignupLinkData,
  GetSignupLinkError,
  GetSignupLinkResponse,
  GetSimulatedProductionData,
  GetSimulatedProductionResponse,
  GetSystemDetailsData,
  GetSystemDetailsResponse,
  GetTasksData,
  GetTasksResponse,
  GetTicketData,
  GetTicketResponse,
  GetTicketsData,
  GetTicketsResponse,
  GetUpgradesData,
  GetUpgradesResponse,
  GetUserData,
  GetUserFeedbackData,
  GetUserFeedbackResponse,
  GetUserPropertiesData,
  GetUserPropertiesResponse,
  GetUserResponse,
  GetWeeklyEnergyBudgetData,
  GetWeeklyEnergyBudgetResponse,
  GetWelcomeCallUrlData,
  GetWelcomeCallUrlResponse,
  GetWrapped2025Data,
  GetWrapped2025Response,
  InitiateEmailChangeData,
  InitiateEmailChangeResponse,
  LoginData,
  LoginResponse,
  MarkProjectViewsData,
  MarkProjectViewsResponse,
  MarkWeeklyEnergyBudgetViewedData,
  PostCouponCodeData,
  PostCouponCodeResponse,
  PostPaymentData,
  PostPaymentResponse,
  PostQuestData,
  PostQuestResponse,
  PostUserFeedbackData,
  PostUserFeedbackResponse,
  PutQuestData,
  PutQuestResponse,
  ReopenConversationData,
  ReopenConversationResponse,
  RestartEmailChangeVerificationData,
  RestartEmailChangeVerificationResponse,
  SearchByAssociatedEntityData,
  SearchByAssociatedEntityError,
  SearchFeedItemsData,
  SearchFeedItemsResponse,
  SearchProductsData,
  SearchProductsResponse,
  SearchSavingsData,
  SearchSavingsResponse,
  SendOtp2Data,
  SendOtp2Response,
  SendOtpData,
  SendOtpResponse,
  SetDefaultPaymentMethodData,
  SetDefaultPaymentMethodResponse,
  SignupData,
  StreamDocumentData,
  SubmitAnswerData,
  SubmitAnswerResponse,
  SubmitCreditApplicationData,
  SubmitCreditApplicationResponse,
  UpdateConnectedAccountData,
  UpdateConnectedAccountResponse,
  UpdateCredentialsData,
  UpdateCredentialsResponse,
  UpdateFeedItemStatusData,
  UpdateFeedItemStatusResponse,
  UpdateProjectFeedItemStatusData,
  UpdateProjectFeedItemStatusResponse,
  UpdatePropertyBuildingData,
  UpdatePropertyData,
  UpdatePropertyResponse,
  UploadMediaData,
  UploadMediaResponse2,
  UploadProjectDocumentsData,
  UploadProjectDocumentsResponse,
  ValidateAgreementData,
  ValidateAgreementResponse,
  VerifyEmailChangeData,
  VerifyEmailChangeResponse,
  VerifyPlaidAccountData,
  VerifyPlaidAccountResponse,
  ViewAchievementData,
  ViewAchievementResponse,
} from "../types.gen";

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, "baseURL" | "body" | "headers" | "path" | "query"> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  }
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseURL:
      options?.baseURL || (options?.client ?? client).getConfig().baseURL,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const getDataQueryKey = (options?: Options<GetDataData>) =>
  createQueryKey("getData", options);

export const getDataOptions = (options?: Options<GetDataData>) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof getDataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getData({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDataQueryKey(options),
  });

export const useGetDataQuery = (options?: Options<GetDataData>) =>
  useQuery(getDataOptions(options));

export const getCurrentUserQueryKey = (options?: Options<GetCurrentUserData>) =>
  createQueryKey("getCurrentUser", options);

export const getCurrentUserOptions = (options?: Options<GetCurrentUserData>) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof getCurrentUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCurrentUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCurrentUserQueryKey(options),
  });

export const useGetCurrentUserQuery = (options?: Options<GetCurrentUserData>) =>
  useQuery(getCurrentUserOptions(options));

export const confirmOtpMutation = (
  options?: Partial<Options<ConfirmOtpData>>
): UseMutationOptions<
  ConfirmOtpResponse2,
  AxiosError<DefaultError>,
  Options<ConfirmOtpData>
> => {
  const mutationOptions: UseMutationOptions<
    ConfirmOtpResponse2,
    AxiosError<DefaultError>,
    Options<ConfirmOtpData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await confirmOtp({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCurrentUserV3QueryKey = (
  options?: Options<GetCurrentUserV3Data>
) => createQueryKey("getCurrentUserV3", options);

export const getCurrentUserV3Options = (
  options?: Options<GetCurrentUserV3Data>
) =>
  queryOptions<
    GetCurrentUserV3Response,
    AxiosError<DefaultError>,
    GetCurrentUserV3Response,
    ReturnType<typeof getCurrentUserV3QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCurrentUserV3({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCurrentUserV3QueryKey(options),
  });

export const useGetCurrentUserV3Query = (
  options?: Options<GetCurrentUserV3Data>
) => useQuery(getCurrentUserV3Options(options));

export const getIntercomJwtQueryKey = (options?: Options<GetIntercomJwtData>) =>
  createQueryKey("getIntercomJwt", options);

export const getIntercomJwtOptions = (options?: Options<GetIntercomJwtData>) =>
  queryOptions<
    GetIntercomJwtResponse,
    AxiosError<DefaultError>,
    GetIntercomJwtResponse,
    ReturnType<typeof getIntercomJwtQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getIntercomJwt({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getIntercomJwtQueryKey(options),
  });

export const useGetIntercomJwtQuery = (options?: Options<GetIntercomJwtData>) =>
  useQuery(getIntercomJwtOptions(options));

export const getMeQueryKey = (options?: Options<GetMeData>) =>
  createQueryKey("getMe", options);

export const getMeOptions = (options?: Options<GetMeData>) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof getMeQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMe({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMeQueryKey(options),
  });

export const useGetMeQuery = (options?: Options<GetMeData>) =>
  useQuery(getMeOptions(options));

export const getUserPropertiesQueryKey = (
  options?: Options<GetUserPropertiesData>
) => createQueryKey("getUserProperties", options);

export const getUserPropertiesOptions = (
  options?: Options<GetUserPropertiesData>
) =>
  queryOptions<
    GetUserPropertiesResponse,
    AxiosError<DefaultError>,
    GetUserPropertiesResponse,
    ReturnType<typeof getUserPropertiesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUserProperties({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUserPropertiesQueryKey(options),
  });

export const useGetUserPropertiesQuery = (
  options?: Options<GetUserPropertiesData>
) => useQuery(getUserPropertiesOptions(options));

/**
 * Create a property for the authenticated user
 */
export const createPropertyMutation = (
  options?: Partial<Options<CreatePropertyData>>
): UseMutationOptions<
  CreatePropertyResponse,
  AxiosError<DefaultError>,
  Options<CreatePropertyData>
> => {
  const mutationOptions: UseMutationOptions<
    CreatePropertyResponse,
    AxiosError<DefaultError>,
    Options<CreatePropertyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createProperty({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPropertyQueryKey = (options: Options<GetPropertyData>) =>
  createQueryKey("getProperty", options);

/**
 * Get a property by id
 */
export const getPropertyOptions = (options: Options<GetPropertyData>) =>
  queryOptions<
    GetPropertyResponse,
    AxiosError<DefaultError>,
    GetPropertyResponse,
    ReturnType<typeof getPropertyQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProperty({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPropertyQueryKey(options),
  });

/**
 * Get a property by id
 */
export const useGetPropertyQuery = (options: Options<GetPropertyData>) =>
  useQuery(getPropertyOptions(options));

/**
 * Update the electric utility and/or address of a property
 */
export const updatePropertyMutation = (
  options?: Partial<Options<UpdatePropertyData>>
): UseMutationOptions<
  UpdatePropertyResponse,
  AxiosError<DefaultError>,
  Options<UpdatePropertyData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdatePropertyResponse,
    AxiosError<DefaultError>,
    Options<UpdatePropertyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateProperty({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getWeeklyEnergyBudgetQueryKey = (
  options: Options<GetWeeklyEnergyBudgetData>
) => createQueryKey("getWeeklyEnergyBudget", options);

export const getWeeklyEnergyBudgetOptions = (
  options: Options<GetWeeklyEnergyBudgetData>
) =>
  queryOptions<
    GetWeeklyEnergyBudgetResponse,
    AxiosError<DefaultError>,
    GetWeeklyEnergyBudgetResponse,
    ReturnType<typeof getWeeklyEnergyBudgetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWeeklyEnergyBudget({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWeeklyEnergyBudgetQueryKey(options),
  });

export const useGetWeeklyEnergyBudgetQuery = (
  options: Options<GetWeeklyEnergyBudgetData>
) => useQuery(getWeeklyEnergyBudgetOptions(options));

export const getCurrentWeeklyEnergyBudgetQueryKey = (
  options: Options<GetCurrentWeeklyEnergyBudgetData>
) => createQueryKey("getCurrentWeeklyEnergyBudget", options);

export const getCurrentWeeklyEnergyBudgetOptions = (
  options: Options<GetCurrentWeeklyEnergyBudgetData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof getCurrentWeeklyEnergyBudgetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCurrentWeeklyEnergyBudget({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCurrentWeeklyEnergyBudgetQueryKey(options),
  });

export const useGetCurrentWeeklyEnergyBudgetQuery = (
  options: Options<GetCurrentWeeklyEnergyBudgetData>
) => useQuery(getCurrentWeeklyEnergyBudgetOptions(options));

export const markWeeklyEnergyBudgetViewedMutation = (
  options?: Partial<Options<MarkWeeklyEnergyBudgetViewedData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<MarkWeeklyEnergyBudgetViewedData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<MarkWeeklyEnergyBudgetViewedData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await markWeeklyEnergyBudgetViewed({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPropertyTariffsQueryKey = (
  options: Options<GetPropertyTariffsData>
) => createQueryKey("getPropertyTariffs", options);

/**
 * Get available tariffs for a property
 */
export const getPropertyTariffsOptions = (
  options: Options<GetPropertyTariffsData>
) =>
  queryOptions<
    GetPropertyTariffsResponse2,
    AxiosError<DefaultError>,
    GetPropertyTariffsResponse2,
    ReturnType<typeof getPropertyTariffsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPropertyTariffs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPropertyTariffsQueryKey(options),
  });

/**
 * Get available tariffs for a property
 */
export const useGetPropertyTariffsQuery = (
  options: Options<GetPropertyTariffsData>
) => useQuery(getPropertyTariffsOptions(options));

export const getPropertyUtilitiesQueryKey = (
  options: Options<GetPropertyUtilitiesData>
) => createQueryKey("getPropertyUtilities", options);

/**
 * Get the potential electric utilities for a property
 */
export const getPropertyUtilitiesOptions = (
  options: Options<GetPropertyUtilitiesData>
) =>
  queryOptions<
    GetPropertyUtilitiesResponse,
    AxiosError<DefaultError>,
    GetPropertyUtilitiesResponse,
    ReturnType<typeof getPropertyUtilitiesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPropertyUtilities({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPropertyUtilitiesQueryKey(options),
  });

/**
 * Get the potential electric utilities for a property
 */
export const useGetPropertyUtilitiesQuery = (
  options: Options<GetPropertyUtilitiesData>
) => useQuery(getPropertyUtilitiesOptions(options));

export const getPropertyAlertsQueryKey = (
  options: Options<GetPropertyAlertsData>
) => createQueryKey("getPropertyAlerts", options);

/**
 * Get alerts for a property
 */
export const getPropertyAlertsOptions = (
  options: Options<GetPropertyAlertsData>
) =>
  queryOptions<
    GetPropertyAlertsResponse,
    AxiosError<DefaultError>,
    GetPropertyAlertsResponse,
    ReturnType<typeof getPropertyAlertsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPropertyAlerts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPropertyAlertsQueryKey(options),
  });

/**
 * Get alerts for a property
 */
export const useGetPropertyAlertsQuery = (
  options: Options<GetPropertyAlertsData>
) => useQuery(getPropertyAlertsOptions(options));

export const getPropertyAlertsDailySeverityQueryKey = (
  options: Options<GetPropertyAlertsDailySeverityData>
) => createQueryKey("getPropertyAlertsDailySeverity", options);

/**
 * Get per-day alert severity for a property over a date range
 *
 * Known limitation: Sienna has no date-range filter or documented sort, so the alert walk is capped (~200 actionable alerts per site). A site whose history exceeds the cap may return incomplete days (some shown as `normal` when they were degraded), logged server-side. Pending a Sienna date-range filter or a guaranteed sort order to make this exact for high-volume sites.
 */
export const getPropertyAlertsDailySeverityOptions = (
  options: Options<GetPropertyAlertsDailySeverityData>
) =>
  queryOptions<
    GetPropertyAlertsDailySeverityResponse,
    AxiosError<DefaultError>,
    GetPropertyAlertsDailySeverityResponse,
    ReturnType<typeof getPropertyAlertsDailySeverityQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPropertyAlertsDailySeverity({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPropertyAlertsDailySeverityQueryKey(options),
  });

/**
 * Get per-day alert severity for a property over a date range
 *
 * Known limitation: Sienna has no date-range filter or documented sort, so the alert walk is capped (~200 actionable alerts per site). A site whose history exceeds the cap may return incomplete days (some shown as `normal` when they were degraded), logged server-side. Pending a Sienna date-range filter or a guaranteed sort order to make this exact for high-volume sites.
 */
export const useGetPropertyAlertsDailySeverityQuery = (
  options: Options<GetPropertyAlertsDailySeverityData>
) => useQuery(getPropertyAlertsDailySeverityOptions(options));

export const getRatePlanEligibilityQueryKey = (
  options: Options<GetRatePlanEligibilityData>
) => createQueryKey("getRatePlanEligibility", options);

/**
 * Get utility rate plan eligibility for a property
 */
export const getRatePlanEligibilityOptions = (
  options: Options<GetRatePlanEligibilityData>
) =>
  queryOptions<
    GetRatePlanEligibilityResponse,
    AxiosError<DefaultError>,
    GetRatePlanEligibilityResponse,
    ReturnType<typeof getRatePlanEligibilityQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRatePlanEligibility({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getRatePlanEligibilityQueryKey(options),
  });

/**
 * Get utility rate plan eligibility for a property
 */
export const useGetRatePlanEligibilityQuery = (
  options: Options<GetRatePlanEligibilityData>
) => useQuery(getRatePlanEligibilityOptions(options));

export const getRatePlanOptionsQueryKey = (
  options: Options<GetRatePlanOptionsData>
) => createQueryKey("getRatePlanOptions", options);

/**
 * Get available utility rate plan options and benchmarks for a property
 */
export const getRatePlanOptionsOptions = (
  options: Options<GetRatePlanOptionsData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof getRatePlanOptionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRatePlanOptions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getRatePlanOptionsQueryKey(options),
  });

/**
 * Get available utility rate plan options and benchmarks for a property
 */
export const useGetRatePlanOptionsQuery = (
  options: Options<GetRatePlanOptionsData>
) => useQuery(getRatePlanOptionsOptions(options));

export const getPropertyWeatherQueryKey = (
  options: Options<GetPropertyWeatherData>
) => createQueryKey("getPropertyWeather", options);

/**
 * Get weather conditions for a property
 */
export const getPropertyWeatherOptions = (
  options: Options<GetPropertyWeatherData>
) =>
  queryOptions<
    GetPropertyWeatherResponse,
    AxiosError<DefaultError>,
    GetPropertyWeatherResponse,
    ReturnType<typeof getPropertyWeatherQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPropertyWeather({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPropertyWeatherQueryKey(options),
  });

/**
 * Get weather conditions for a property
 */
export const useGetPropertyWeatherQuery = (
  options: Options<GetPropertyWeatherData>
) => useQuery(getPropertyWeatherOptions(options));

export const getPropertyEnergyMaxQueryKey = (
  options: Options<GetPropertyEnergyMaxData>
) => createQueryKey("getPropertyEnergyMax", options);

/**
 * Get the largest energy reading over a property lifetime, for a given interval
 */
export const getPropertyEnergyMaxOptions = (
  options: Options<GetPropertyEnergyMaxData>
) =>
  queryOptions<
    GetPropertyEnergyMaxResponse,
    AxiosError<DefaultError>,
    GetPropertyEnergyMaxResponse,
    ReturnType<typeof getPropertyEnergyMaxQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPropertyEnergyMax({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPropertyEnergyMaxQueryKey(options),
  });

/**
 * Get the largest energy reading over a property lifetime, for a given interval
 */
export const useGetPropertyEnergyMaxQuery = (
  options: Options<GetPropertyEnergyMaxData>
) => useQuery(getPropertyEnergyMaxOptions(options));

export const getPropertyBatteryEnergyTotalsQueryKey = (
  options: Options<GetPropertyBatteryEnergyTotalsData>
) => createQueryKey("getPropertyBatteryEnergyTotals", options);

/**
 * Get the energy charged into and discharged from a property battery on a given date
 */
export const getPropertyBatteryEnergyTotalsOptions = (
  options: Options<GetPropertyBatteryEnergyTotalsData>
) =>
  queryOptions<
    GetPropertyBatteryEnergyTotalsResponse,
    AxiosError<DefaultError>,
    GetPropertyBatteryEnergyTotalsResponse,
    ReturnType<typeof getPropertyBatteryEnergyTotalsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPropertyBatteryEnergyTotals({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPropertyBatteryEnergyTotalsQueryKey(options),
  });

/**
 * Get the energy charged into and discharged from a property battery on a given date
 */
export const useGetPropertyBatteryEnergyTotalsQuery = (
  options: Options<GetPropertyBatteryEnergyTotalsData>
) => useQuery(getPropertyBatteryEnergyTotalsOptions(options));

export const updatePropertyBuildingMutation = (
  options?: Partial<Options<UpdatePropertyBuildingData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<UpdatePropertyBuildingData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<UpdatePropertyBuildingData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updatePropertyBuilding({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Search savings data for a property over a date range
 */
export const searchSavingsMutation = (
  options?: Partial<Options<SearchSavingsData>>
): UseMutationOptions<
  SearchSavingsResponse,
  AxiosError<DefaultError>,
  Options<SearchSavingsData>
> => {
  const mutationOptions: UseMutationOptions<
    SearchSavingsResponse,
    AxiosError<DefaultError>,
    Options<SearchSavingsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await searchSavings({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getLifetimeSavingsQueryKey = (
  options: Options<GetLifetimeSavingsData>
) => createQueryKey("getLifetimeSavings", options);

/**
 * Get total lifetime savings for a property
 */
export const getLifetimeSavingsOptions = (
  options: Options<GetLifetimeSavingsData>
) =>
  queryOptions<
    GetLifetimeSavingsResponse,
    AxiosError<DefaultError>,
    GetLifetimeSavingsResponse,
    ReturnType<typeof getLifetimeSavingsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLifetimeSavings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLifetimeSavingsQueryKey(options),
  });

/**
 * Get total lifetime savings for a property
 */
export const useGetLifetimeSavingsQuery = (
  options: Options<GetLifetimeSavingsData>
) => useQuery(getLifetimeSavingsOptions(options));

export const getConnectedAccountsQueryKey = (
  options?: Options<GetConnectedAccountsData>
) => createQueryKey("getConnectedAccounts", options);

/**
 * Get connected accounts for the authenticated user
 */
export const getConnectedAccountsOptions = (
  options?: Options<GetConnectedAccountsData>
) =>
  queryOptions<
    GetConnectedAccountsResponse,
    AxiosError<DefaultError>,
    GetConnectedAccountsResponse,
    ReturnType<typeof getConnectedAccountsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getConnectedAccounts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getConnectedAccountsQueryKey(options),
  });

/**
 * Get connected accounts for the authenticated user
 */
export const useGetConnectedAccountsQuery = (
  options?: Options<GetConnectedAccountsData>
) => useQuery(getConnectedAccountsOptions(options));

/**
 * Create a new connected account
 */
export const createConnectedAccountMutation = (
  options?: Partial<Options<CreateConnectedAccountData>>
): UseMutationOptions<
  CreateConnectedAccountResponse,
  AxiosError<DefaultError>,
  Options<CreateConnectedAccountData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateConnectedAccountResponse,
    AxiosError<DefaultError>,
    Options<CreateConnectedAccountData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createConnectedAccount({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const createMfaRefreshSessionQueryKey = (
  options: Options<CreateMfaRefreshSessionData>
) => createQueryKey("createMfaRefreshSession", options);

/**
 * Create an MFA refresh session for a connected account
 */
export const createMfaRefreshSessionOptions = (
  options: Options<CreateMfaRefreshSessionData>
) =>
  queryOptions<
    CreateMfaRefreshSessionResponse,
    AxiosError<DefaultError>,
    CreateMfaRefreshSessionResponse,
    ReturnType<typeof createMfaRefreshSessionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createMfaRefreshSession({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createMfaRefreshSessionQueryKey(options),
  });

/**
 * Create an MFA refresh session for a connected account
 */
export const useCreateMfaRefreshSessionQuery = (
  options: Options<CreateMfaRefreshSessionData>
) => useQuery(createMfaRefreshSessionOptions(options));

export const updateCredentialsQueryKey = (
  options: Options<UpdateCredentialsData>
) => createQueryKey("updateCredentials", options);

/**
 * Create a credential update session for a connected account
 */
export const updateCredentialsOptions = (
  options: Options<UpdateCredentialsData>
) =>
  queryOptions<
    UpdateCredentialsResponse,
    AxiosError<DefaultError>,
    UpdateCredentialsResponse,
    ReturnType<typeof updateCredentialsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await updateCredentials({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: updateCredentialsQueryKey(options),
  });

/**
 * Create a credential update session for a connected account
 */
export const useUpdateCredentialsQuery = (
  options: Options<UpdateCredentialsData>
) => useQuery(updateCredentialsOptions(options));

/**
 * Delete a connected account
 */
export const deleteConnectedAccountMutation = (
  options?: Partial<Options<DeleteConnectedAccountData>>
): UseMutationOptions<
  DeleteConnectedAccountResponse,
  AxiosError<DefaultError>,
  Options<DeleteConnectedAccountData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteConnectedAccountResponse,
    AxiosError<DefaultError>,
    Options<DeleteConnectedAccountData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteConnectedAccount({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update connected account status
 */
export const updateConnectedAccountMutation = (
  options?: Partial<Options<UpdateConnectedAccountData>>
): UseMutationOptions<
  UpdateConnectedAccountResponse,
  AxiosError<DefaultError>,
  Options<UpdateConnectedAccountData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateConnectedAccountResponse,
    AxiosError<DefaultError>,
    Options<UpdateConnectedAccountData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateConnectedAccount({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getAchievementsQueryKey = (
  options?: Options<GetAchievementsData>
) => createQueryKey("getAchievements", options);

/**
 * Get achievements for the authenticated user
 */
export const getAchievementsOptions = (
  options?: Options<GetAchievementsData>
) =>
  queryOptions<
    GetAchievementsResponse,
    AxiosError<DefaultError>,
    GetAchievementsResponse,
    ReturnType<typeof getAchievementsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAchievements({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAchievementsQueryKey(options),
  });

/**
 * Get achievements for the authenticated user
 */
export const useGetAchievementsQuery = (
  options?: Options<GetAchievementsData>
) => useQuery(getAchievementsOptions(options));

/**
 * Mark an achievement as viewed
 */
export const viewAchievementMutation = (
  options?: Partial<Options<ViewAchievementData>>
): UseMutationOptions<
  ViewAchievementResponse,
  AxiosError<DefaultError>,
  Options<ViewAchievementData>
> => {
  const mutationOptions: UseMutationOptions<
    ViewAchievementResponse,
    AxiosError<DefaultError>,
    Options<ViewAchievementData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await viewAchievement({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const initiateEmailChangeMutation = (
  options?: Partial<Options<InitiateEmailChangeData>>
): UseMutationOptions<
  InitiateEmailChangeResponse,
  AxiosError<DefaultError>,
  Options<InitiateEmailChangeData>
> => {
  const mutationOptions: UseMutationOptions<
    InitiateEmailChangeResponse,
    AxiosError<DefaultError>,
    Options<InitiateEmailChangeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await initiateEmailChange({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const verifyEmailChangeMutation = (
  options?: Partial<Options<VerifyEmailChangeData>>
): UseMutationOptions<
  VerifyEmailChangeResponse,
  AxiosError<DefaultError>,
  Options<VerifyEmailChangeData>
> => {
  const mutationOptions: UseMutationOptions<
    VerifyEmailChangeResponse,
    AxiosError<DefaultError>,
    Options<VerifyEmailChangeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await verifyEmailChange({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const restartEmailChangeVerificationMutation = (
  options?: Partial<Options<RestartEmailChangeVerificationData>>
): UseMutationOptions<
  RestartEmailChangeVerificationResponse,
  AxiosError<DefaultError>,
  Options<RestartEmailChangeVerificationData>
> => {
  const mutationOptions: UseMutationOptions<
    RestartEmailChangeVerificationResponse,
    AxiosError<DefaultError>,
    Options<RestartEmailChangeVerificationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await restartEmailChangeVerification({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Get AI-generated quiz questions
 *
 * Returns quiz questions for a literature URL, excluding previously answered ones. Generates if needed.
 */
export const getQuizQuestionsMutation = (
  options?: Partial<Options<GetQuizQuestionsData>>
): UseMutationOptions<
  GetQuizQuestionsResponse,
  AxiosError<DefaultError>,
  Options<GetQuizQuestionsData>
> => {
  const mutationOptions: UseMutationOptions<
    GetQuizQuestionsResponse,
    AxiosError<DefaultError>,
    Options<GetQuizQuestionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await getQuizQuestions({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getProductSavingsQueryKey = (
  options: Options<GetProductSavingsData>
) => createQueryKey("getProductSavings", options);

/**
 * Get savings estimate for a single product
 */
export const getProductSavingsOptions = (
  options: Options<GetProductSavingsData>
) =>
  queryOptions<
    GetProductSavingsResponse,
    AxiosError<DefaultError>,
    GetProductSavingsResponse,
    ReturnType<typeof getProductSavingsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProductSavings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProductSavingsQueryKey(options),
  });

/**
 * Get savings estimate for a single product
 */
export const useGetProductSavingsQuery = (
  options: Options<GetProductSavingsData>
) => useQuery(getProductSavingsOptions(options));

export const getManufacturersQueryKey = (
  options?: Options<GetManufacturersData>
) => createQueryKey("getManufacturers", options);

/**
 * Get all unique manufacturers from helios products
 */
export const getManufacturersOptions = (
  options?: Options<GetManufacturersData>
) =>
  queryOptions<
    GetManufacturersResponse,
    AxiosError<DefaultError>,
    GetManufacturersResponse,
    ReturnType<typeof getManufacturersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getManufacturers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getManufacturersQueryKey(options),
  });

/**
 * Get all unique manufacturers from helios products
 */
export const useGetManufacturersQuery = (
  options?: Options<GetManufacturersData>
) => useQuery(getManufacturersOptions(options));

export const getProductQueryKey = (options: Options<GetProductData>) =>
  createQueryKey("getProduct", options);

/**
 * Get a single helios product by classification ID. Auth is optional.
 */
export const getProductOptions = (options: Options<GetProductData>) =>
  queryOptions<
    GetProductResponse,
    AxiosError<DefaultError>,
    GetProductResponse,
    ReturnType<typeof getProductQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProduct({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProductQueryKey(options),
  });

/**
 * Get a single helios product by classification ID. Auth is optional.
 */
export const useGetProductQuery = (options: Options<GetProductData>) =>
  useQuery(getProductOptions(options));

/**
 * Redeem a coupon code using points
 */
export const postCouponCodeMutation = (
  options?: Partial<Options<PostCouponCodeData>>
): UseMutationOptions<
  PostCouponCodeResponse,
  AxiosError<DefaultError>,
  Options<PostCouponCodeData>
> => {
  const mutationOptions: UseMutationOptions<
    PostCouponCodeResponse,
    AxiosError<DefaultError>,
    Options<PostCouponCodeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await postCouponCode({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Search helios products, optionally filtered by user eligibility. Auth is optional.
 */
export const searchProductsMutation = (
  options?: Partial<Options<SearchProductsData>>
): UseMutationOptions<
  SearchProductsResponse,
  AxiosError<DefaultError>,
  Options<SearchProductsData>
> => {
  const mutationOptions: UseMutationOptions<
    SearchProductsResponse,
    AxiosError<DefaultError>,
    Options<SearchProductsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await searchProducts({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getFeaturedManufacturersQueryKey = (
  options?: Options<GetFeaturedManufacturersData>
) => createQueryKey("getFeaturedManufacturers", options);

/**
 * Get featured manufacturers for the shop
 */
export const getFeaturedManufacturersOptions = (
  options?: Options<GetFeaturedManufacturersData>
) =>
  queryOptions<
    GetFeaturedManufacturersResponse,
    AxiosError<DefaultError>,
    GetFeaturedManufacturersResponse,
    ReturnType<typeof getFeaturedManufacturersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFeaturedManufacturers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFeaturedManufacturersQueryKey(options),
  });

/**
 * Get featured manufacturers for the shop
 */
export const useGetFeaturedManufacturersQuery = (
  options?: Options<GetFeaturedManufacturersData>
) => useQuery(getFeaturedManufacturersOptions(options));

export const getUpgradesQueryKey = (options?: Options<GetUpgradesData>) =>
  createQueryKey("getUpgrades", options);

/**
 * Get shop upgrades.
 */
export const getUpgradesOptions = (options?: Options<GetUpgradesData>) =>
  queryOptions<
    GetUpgradesResponse,
    AxiosError<DefaultError>,
    GetUpgradesResponse,
    ReturnType<typeof getUpgradesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUpgrades({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUpgradesQueryKey(options),
  });

/**
 * Get shop upgrades.
 */
export const useGetUpgradesQuery = (options?: Options<GetUpgradesData>) =>
  useQuery(getUpgradesOptions(options));

export const getProjectsQueryKey = (options?: Options<GetProjectsData>) =>
  createQueryKey("getProjects", options);

export const getProjectsOptions = (options?: Options<GetProjectsData>) =>
  queryOptions<
    GetProjectsResponse,
    AxiosError<DefaultError>,
    GetProjectsResponse,
    ReturnType<typeof getProjectsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjects({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProjectsQueryKey(options),
  });

export const useGetProjectsQuery = (options?: Options<GetProjectsData>) =>
  useQuery(getProjectsOptions(options));

/**
 * Create a project for the authenticated user from a consumer reservation or their Sabal accounts
 */
export const createProjectMutation = (
  options?: Partial<Options<CreateProjectData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<CreateProjectData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<CreateProjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getProjectQueryKey = (options: Options<GetProjectData>) =>
  createQueryKey("getProject", options);

export const getProjectOptions = (options: Options<GetProjectData>) =>
  queryOptions<
    GetProjectResponse,
    AxiosError<DefaultError>,
    GetProjectResponse,
    ReturnType<typeof getProjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProjectQueryKey(options),
  });

export const useGetProjectQuery = (options: Options<GetProjectData>) =>
  useQuery(getProjectOptions(options));

/**
 * Cancel a project for the authenticated user
 */
export const cancelProjectMutation = (
  options?: Partial<Options<CancelProjectData>>
): UseMutationOptions<
  CancelProjectResponse,
  AxiosError<DefaultError>,
  Options<CancelProjectData>
> => {
  const mutationOptions: UseMutationOptions<
    CancelProjectResponse,
    AxiosError<DefaultError>,
    Options<CancelProjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await cancelProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Mark the current stage education sequence and/or project timeline as viewed
 */
export const markProjectViewsMutation = (
  options?: Partial<Options<MarkProjectViewsData>>
): UseMutationOptions<
  MarkProjectViewsResponse,
  AxiosError<DefaultError>,
  Options<MarkProjectViewsData>
> => {
  const mutationOptions: UseMutationOptions<
    MarkProjectViewsResponse,
    AxiosError<DefaultError>,
    Options<MarkProjectViewsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await markProjectViews({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update the status of a feed item, identified by type, for a project owned by the authenticated user
 */
export const updateProjectFeedItemStatusMutation = (
  options?: Partial<Options<UpdateProjectFeedItemStatusData>>
): UseMutationOptions<
  UpdateProjectFeedItemStatusResponse,
  AxiosError<DefaultError>,
  Options<UpdateProjectFeedItemStatusData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateProjectFeedItemStatusResponse,
    AxiosError<DefaultError>,
    Options<UpdateProjectFeedItemStatusData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateProjectFeedItemStatus({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCreditApplicationUrlQueryKey = (
  options?: Options<GetCreditApplicationUrlData>
) => createQueryKey("getCreditApplicationUrl", options);

export const getCreditApplicationUrlOptions = (
  options?: Options<GetCreditApplicationUrlData>
) =>
  queryOptions<
    GetCreditApplicationUrlResponse,
    AxiosError<DefaultError>,
    GetCreditApplicationUrlResponse,
    ReturnType<typeof getCreditApplicationUrlQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCreditApplicationUrl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCreditApplicationUrlQueryKey(options),
  });

export const useGetCreditApplicationUrlQuery = (
  options?: Options<GetCreditApplicationUrlData>
) => useQuery(getCreditApplicationUrlOptions(options));

export const getContractSignUrlQueryKey = (
  options: Options<GetContractSignUrlData>
) => createQueryKey("getContractSignUrl", options);

export const getContractSignUrlOptions = (
  options: Options<GetContractSignUrlData>
) =>
  queryOptions<
    GetContractSignUrlResponse,
    AxiosError<DefaultError>,
    GetContractSignUrlResponse,
    ReturnType<typeof getContractSignUrlQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getContractSignUrl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getContractSignUrlQueryKey(options),
  });

export const useGetContractSignUrlQuery = (
  options: Options<GetContractSignUrlData>
) => useQuery(getContractSignUrlOptions(options));

export const getWelcomeCallUrlQueryKey = (
  options: Options<GetWelcomeCallUrlData>
) => createQueryKey("getWelcomeCallUrl", options);

export const getWelcomeCallUrlOptions = (
  options: Options<GetWelcomeCallUrlData>
) =>
  queryOptions<
    GetWelcomeCallUrlResponse,
    AxiosError<DefaultError>,
    GetWelcomeCallUrlResponse,
    ReturnType<typeof getWelcomeCallUrlQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWelcomeCallUrl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWelcomeCallUrlQueryKey(options),
  });

export const useGetWelcomeCallUrlQuery = (
  options: Options<GetWelcomeCallUrlData>
) => useQuery(getWelcomeCallUrlOptions(options));

export const completeWelcomeCallQueryKey = (
  options: Options<CompleteWelcomeCallData>
) => createQueryKey("completeWelcomeCall", options);

export const completeWelcomeCallOptions = (
  options: Options<CompleteWelcomeCallData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof completeWelcomeCallQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await completeWelcomeCall({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: completeWelcomeCallQueryKey(options),
  });

export const useCompleteWelcomeCallQuery = (
  options: Options<CompleteWelcomeCallData>
) => useQuery(completeWelcomeCallOptions(options));

export const getSystemDetailsQueryKey = (
  options: Options<GetSystemDetailsData>
) => createQueryKey("getSystemDetails", options);

export const getSystemDetailsOptions = (
  options: Options<GetSystemDetailsData>
) =>
  queryOptions<
    GetSystemDetailsResponse,
    AxiosError<DefaultError>,
    GetSystemDetailsResponse,
    ReturnType<typeof getSystemDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSystemDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSystemDetailsQueryKey(options),
  });

export const useGetSystemDetailsQuery = (
  options: Options<GetSystemDetailsData>
) => useQuery(getSystemDetailsOptions(options));

export const getActiveQuoteQueryKey = (options: Options<GetActiveQuoteData>) =>
  createQueryKey("getActiveQuote", options);

export const getActiveQuoteOptions = (options: Options<GetActiveQuoteData>) =>
  queryOptions<
    GetActiveQuoteResponse,
    AxiosError<DefaultError>,
    GetActiveQuoteResponse,
    ReturnType<typeof getActiveQuoteQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getActiveQuote({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getActiveQuoteQueryKey(options),
  });

export const useGetActiveQuoteQuery = (options: Options<GetActiveQuoteData>) =>
  useQuery(getActiveQuoteOptions(options));

export const getProjectDisclosuresQueryKey = (
  options: Options<GetProjectDisclosuresData>
) => createQueryKey("getProjectDisclosures", options);

/**
 * Get disclosures for this project from the financing partner
 */
export const getProjectDisclosuresOptions = (
  options: Options<GetProjectDisclosuresData>
) =>
  queryOptions<
    GetProjectDisclosuresResponse2,
    AxiosError<DefaultError>,
    GetProjectDisclosuresResponse2,
    ReturnType<typeof getProjectDisclosuresQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectDisclosures({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProjectDisclosuresQueryKey(options),
  });

/**
 * Get disclosures for this project from the financing partner
 */
export const useGetProjectDisclosuresQuery = (
  options: Options<GetProjectDisclosuresData>
) => useQuery(getProjectDisclosuresOptions(options));

export const getEstimatedProductionQueryKey = (
  options: Options<GetEstimatedProductionData>
) => createQueryKey("getEstimatedProduction", options);

/**
 * Get BEM-estimated production series for this project
 */
export const getEstimatedProductionOptions = (
  options: Options<GetEstimatedProductionData>
) =>
  queryOptions<
    GetEstimatedProductionResponse2,
    AxiosError<DefaultError>,
    GetEstimatedProductionResponse2,
    ReturnType<typeof getEstimatedProductionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEstimatedProduction({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEstimatedProductionQueryKey(options),
  });

/**
 * Get BEM-estimated production series for this project
 */
export const useGetEstimatedProductionQuery = (
  options: Options<GetEstimatedProductionData>
) => useQuery(getEstimatedProductionOptions(options));

export const getSimulatedProductionQueryKey = (
  options: Options<GetSimulatedProductionData>
) => createQueryKey("getSimulatedProduction", options);

/**
 * Get BEM-simulated production so far for today, this week and this year
 */
export const getSimulatedProductionOptions = (
  options: Options<GetSimulatedProductionData>
) =>
  queryOptions<
    GetSimulatedProductionResponse,
    AxiosError<DefaultError>,
    GetSimulatedProductionResponse,
    ReturnType<typeof getSimulatedProductionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSimulatedProduction({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSimulatedProductionQueryKey(options),
  });

/**
 * Get BEM-simulated production so far for today, this week and this year
 */
export const useGetSimulatedProductionQuery = (
  options: Options<GetSimulatedProductionData>
) => useQuery(getSimulatedProductionOptions(options));

/**
 * Submit a credit application to the financing partner for this project
 */
export const submitCreditApplicationMutation = (
  options?: Partial<Options<SubmitCreditApplicationData>>
): UseMutationOptions<
  SubmitCreditApplicationResponse,
  AxiosError<DefaultError>,
  Options<SubmitCreditApplicationData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitCreditApplicationResponse,
    AxiosError<DefaultError>,
    Options<SubmitCreditApplicationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await submitCreditApplication({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create a Stripe identity verification session for this project
 */
export const createIdentityVerificationSetupMutation = (
  options?: Partial<Options<CreateIdentityVerificationSetupData>>
): UseMutationOptions<
  CreateIdentityVerificationSetupResponse,
  AxiosError<DefaultError>,
  Options<CreateIdentityVerificationSetupData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateIdentityVerificationSetupResponse,
    AxiosError<DefaultError>,
    Options<CreateIdentityVerificationSetupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createIdentityVerificationSetup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getProjectDocumentsQueryKey = (
  options: Options<GetProjectDocumentsData>
) => createQueryKey("getProjectDocuments", options);

/**
 * Get the signed documents (contracts, disclosures, questionnaires) for this project
 */
export const getProjectDocumentsOptions = (
  options: Options<GetProjectDocumentsData>
) =>
  queryOptions<
    GetProjectDocumentsResponse,
    AxiosError<DefaultError>,
    GetProjectDocumentsResponse,
    ReturnType<typeof getProjectDocumentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectDocuments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProjectDocumentsQueryKey(options),
  });

/**
 * Get the signed documents (contracts, disclosures, questionnaires) for this project
 */
export const useGetProjectDocumentsQuery = (
  options: Options<GetProjectDocumentsData>
) => useQuery(getProjectDocumentsOptions(options));

/**
 * Upload documents that fulfill a feed item requirement for this project
 */
export const uploadProjectDocumentsMutation = (
  options?: Partial<Options<UploadProjectDocumentsData>>
): UseMutationOptions<
  UploadProjectDocumentsResponse,
  AxiosError<DefaultError>,
  Options<UploadProjectDocumentsData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadProjectDocumentsResponse,
    AxiosError<DefaultError>,
    Options<UploadProjectDocumentsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadProjectDocuments({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const streamDocumentQueryKey = (options: Options<StreamDocumentData>) =>
  createQueryKey("streamDocument", options);

/**
 * Stream a project document from the financing partner
 */
export const streamDocumentOptions = (options: Options<StreamDocumentData>) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof streamDocumentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await streamDocument({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: streamDocumentQueryKey(options),
  });

/**
 * Stream a project document from the financing partner
 */
export const useStreamDocumentQuery = (options: Options<StreamDocumentData>) =>
  useQuery(streamDocumentOptions(options));

export const getQuestionnaireQueryKey = (
  options: Options<GetQuestionnaireData>
) => createQueryKey("getQuestionnaire", options);

/**
 * Get a questionnaire by id for the authenticated user
 */
export const getQuestionnaireOptions = (
  options: Options<GetQuestionnaireData>
) =>
  queryOptions<
    GetQuestionnaireResponse,
    AxiosError<DefaultError>,
    GetQuestionnaireResponse,
    ReturnType<typeof getQuestionnaireQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getQuestionnaire({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getQuestionnaireQueryKey(options),
  });

/**
 * Get a questionnaire by id for the authenticated user
 */
export const useGetQuestionnaireQuery = (
  options: Options<GetQuestionnaireData>
) => useQuery(getQuestionnaireOptions(options));

/**
 * Create a signature for the authenticated user
 */
export const createSignatureMutation = (
  options?: Partial<Options<CreateSignatureData>>
): UseMutationOptions<
  CreateSignatureResponse2,
  AxiosError<DefaultError>,
  Options<CreateSignatureData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateSignatureResponse2,
    AxiosError<DefaultError>,
    Options<CreateSignatureData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createSignature({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getConversationsQueryKey = (
  options?: Options<GetConversationsData>
) => createQueryKey("getConversations", options);

/**
 * Get paginated Intercom conversation history for the authenticated user
 */
export const getConversationsOptions = (
  options?: Options<GetConversationsData>
) =>
  queryOptions<
    GetConversationsResponse,
    AxiosError<DefaultError>,
    GetConversationsResponse,
    ReturnType<typeof getConversationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getConversations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getConversationsQueryKey(options),
  });

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], "body" | "headers" | "path" | "query">
>(
  queryKey: QueryKey<Options>,
  page: K
) => {
  const params = { ...queryKey[0] };
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    };
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    };
  }
  return params as unknown as typeof page;
};

export const getConversationsInfiniteQueryKey = (
  options?: Options<GetConversationsData>
): QueryKey<Options<GetConversationsData>> =>
  createQueryKey("getConversations", options, true);

/**
 * Get paginated Intercom conversation history for the authenticated user
 */
export const getConversationsInfiniteOptions = (
  options?: Options<GetConversationsData>
) =>
  infiniteQueryOptions<
    GetConversationsResponse,
    AxiosError<DefaultError>,
    InfiniteData<GetConversationsResponse>,
    QueryKey<Options<GetConversationsData>>,
    | string
    | Pick<
        QueryKey<Options<GetConversationsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetConversationsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getConversations({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getConversationsInfiniteQueryKey(options),
    }
  );

/**
 * Get paginated Intercom conversation history for the authenticated user
 */
export const useGetConversationsQuery = (
  options?: Options<GetConversationsData>
) => useQuery(getConversationsOptions(options));

/**
 * Reopen a closed Intercom conversation for the authenticated user
 */
export const reopenConversationMutation = (
  options?: Partial<Options<ReopenConversationData>>
): UseMutationOptions<
  ReopenConversationResponse,
  AxiosError<DefaultError>,
  Options<ReopenConversationData>
> => {
  const mutationOptions: UseMutationOptions<
    ReopenConversationResponse,
    AxiosError<DefaultError>,
    Options<ReopenConversationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await reopenConversation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getTicketsQueryKey = (options?: Options<GetTicketsData>) =>
  createQueryKey("getTickets", options);

/**
 * Get paginated external-facing support tickets for the authenticated user
 */
export const getTicketsOptions = (options?: Options<GetTicketsData>) =>
  queryOptions<
    GetTicketsResponse,
    AxiosError<DefaultError>,
    GetTicketsResponse,
    ReturnType<typeof getTicketsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTickets({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTicketsQueryKey(options),
  });

export const getTicketsInfiniteQueryKey = (
  options?: Options<GetTicketsData>
): QueryKey<Options<GetTicketsData>> =>
  createQueryKey("getTickets", options, true);

/**
 * Get paginated external-facing support tickets for the authenticated user
 */
export const getTicketsInfiniteOptions = (options?: Options<GetTicketsData>) =>
  infiniteQueryOptions<
    GetTicketsResponse,
    AxiosError<DefaultError>,
    InfiniteData<GetTicketsResponse>,
    QueryKey<Options<GetTicketsData>>,
    | string
    | Pick<
        QueryKey<Options<GetTicketsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetTicketsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getTickets({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getTicketsInfiniteQueryKey(options),
    }
  );

/**
 * Get paginated external-facing support tickets for the authenticated user
 */
export const useGetTicketsQuery = (options?: Options<GetTicketsData>) =>
  useQuery(getTicketsOptions(options));

export const getTicketQueryKey = (options: Options<GetTicketData>) =>
  createQueryKey("getTicket", options);

/**
 * Get one external-facing support ticket for the authenticated user
 */
export const getTicketOptions = (options: Options<GetTicketData>) =>
  queryOptions<
    GetTicketResponse,
    AxiosError<DefaultError>,
    GetTicketResponse,
    ReturnType<typeof getTicketQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTicket({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTicketQueryKey(options),
  });

/**
 * Get one external-facing support ticket for the authenticated user
 */
export const useGetTicketQuery = (options: Options<GetTicketData>) =>
  useQuery(getTicketOptions(options));

export const getDocumentQueryKey = (options: Options<GetDocumentData>) =>
  createQueryKey("getDocument", options);

/**
 * Get the latest version of a customer terms document
 */
export const getDocumentOptions = (options: Options<GetDocumentData>) =>
  queryOptions<
    GetDocumentResponse,
    AxiosError<DefaultError>,
    GetDocumentResponse,
    ReturnType<typeof getDocumentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDocument({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDocumentQueryKey(options),
  });

/**
 * Get the latest version of a customer terms document
 */
export const useGetDocumentQuery = (options: Options<GetDocumentData>) =>
  useQuery(getDocumentOptions(options));

export const validateAgreementQueryKey = (
  options: Options<ValidateAgreementData>
) => createQueryKey("validateAgreement", options);

/**
 * Check whether the authenticated user has agreed to the latest version of a term
 */
export const validateAgreementOptions = (
  options: Options<ValidateAgreementData>
) =>
  queryOptions<
    ValidateAgreementResponse,
    AxiosError<DefaultError>,
    ValidateAgreementResponse,
    ReturnType<typeof validateAgreementQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await validateAgreement({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: validateAgreementQueryKey(options),
  });

/**
 * Check whether the authenticated user has agreed to the latest version of a term
 */
export const useValidateAgreementQuery = (
  options: Options<ValidateAgreementData>
) => useQuery(validateAgreementOptions(options));

/**
 * Record that the authenticated user has agreed to the latest version of a term
 */
export const createAgreementMutation = (
  options?: Partial<Options<CreateAgreementData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<CreateAgreementData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<CreateAgreementData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createAgreement({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getQuestionsQueryKey = (options?: Options<GetQuestionsData>) =>
  createQueryKey("getQuestions", options);

export const getQuestionsOptions = (options?: Options<GetQuestionsData>) =>
  queryOptions<
    GetQuestionsResponse,
    AxiosError<DefaultError>,
    GetQuestionsResponse,
    ReturnType<typeof getQuestionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getQuestions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getQuestionsQueryKey(options),
  });

export const useGetQuestionsQuery = (options?: Options<GetQuestionsData>) =>
  useQuery(getQuestionsOptions(options));

export const submitAnswerMutation = (
  options?: Partial<Options<SubmitAnswerData>>
): UseMutationOptions<
  SubmitAnswerResponse,
  AxiosError<DefaultError>,
  Options<SubmitAnswerData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitAnswerResponse,
    AxiosError<DefaultError>,
    Options<SubmitAnswerData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await submitAnswer({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getInsightsQueryKey = (options?: Options<GetInsightsData>) =>
  createQueryKey("getInsights", options);

/**
 * Get insights for the authenticated user
 */
export const getInsightsOptions = (options?: Options<GetInsightsData>) =>
  queryOptions<
    GetInsightsResponse,
    AxiosError<DefaultError>,
    GetInsightsResponse,
    ReturnType<typeof getInsightsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInsights({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getInsightsQueryKey(options),
  });

/**
 * Get insights for the authenticated user
 */
export const useGetInsightsQuery = (options?: Options<GetInsightsData>) =>
  useQuery(getInsightsOptions(options));

/**
 * Create insights for a custom date range
 */
export const createInsightMutation = (
  options?: Partial<Options<CreateInsightData>>
): UseMutationOptions<
  CreateInsightResponse,
  AxiosError<DefaultError>,
  Options<CreateInsightData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateInsightResponse,
    AxiosError<DefaultError>,
    Options<CreateInsightData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createInsight({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getLatestInsightQueryKey = (
  options?: Options<GetLatestInsightData>
) => createQueryKey("getLatestInsight", options);

/**
 * Get the latest insight for the authenticated user
 */
export const getLatestInsightOptions = (
  options?: Options<GetLatestInsightData>
) =>
  queryOptions<
    GetLatestInsightResponse,
    AxiosError<DefaultError>,
    GetLatestInsightResponse,
    ReturnType<typeof getLatestInsightQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLatestInsight({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLatestInsightQueryKey(options),
  });

/**
 * Get the latest insight for the authenticated user
 */
export const useGetLatestInsightQuery = (
  options?: Options<GetLatestInsightData>
) => useQuery(getLatestInsightOptions(options));

export const getInsightQueryKey = (options: Options<GetInsightData>) =>
  createQueryKey("getInsight", options);

/**
 * Get a specific insight by ID for the authenticated user
 */
export const getInsightOptions = (options: Options<GetInsightData>) =>
  queryOptions<
    GetInsightResponse,
    AxiosError<DefaultError>,
    GetInsightResponse,
    ReturnType<typeof getInsightQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInsight({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getInsightQueryKey(options),
  });

/**
 * Get a specific insight by ID for the authenticated user
 */
export const useGetInsightQuery = (options: Options<GetInsightData>) =>
  useQuery(getInsightOptions(options));

export const searchByAssociatedEntityQueryKey = (
  options: Options<SearchByAssociatedEntityData>
) => createQueryKey("searchByAssociatedEntity", options);

/**
 * Search properties by associated entity type and ID
 */
export const searchByAssociatedEntityOptions = (
  options: Options<SearchByAssociatedEntityData>
) =>
  queryOptions<
    unknown,
    AxiosError<SearchByAssociatedEntityError>,
    unknown,
    ReturnType<typeof searchByAssociatedEntityQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await searchByAssociatedEntity({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: searchByAssociatedEntityQueryKey(options),
  });

/**
 * Search properties by associated entity type and ID
 */
export const useSearchByAssociatedEntityQuery = (
  options: Options<SearchByAssociatedEntityData>
) => useQuery(searchByAssociatedEntityOptions(options));

/**
 * Generate an invite link or return existing user info
 */
export const getSignupLinkMutation = (
  options?: Partial<Options<GetSignupLinkData>>
): UseMutationOptions<
  GetSignupLinkResponse,
  AxiosError<GetSignupLinkError>,
  Options<GetSignupLinkData>
> => {
  const mutationOptions: UseMutationOptions<
    GetSignupLinkResponse,
    AxiosError<GetSignupLinkError>,
    Options<GetSignupLinkData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await getSignupLink({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Send an invite email with a signup link
 */
export const createInviteMutation = (
  options?: Partial<Options<CreateInviteData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<CreateInviteData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<CreateInviteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createInvite({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getTasksQueryKey = (options?: Options<GetTasksData>) =>
  createQueryKey("getTasks", options);

/**
 * Get all available tasks
 */
export const getTasksOptions = (options?: Options<GetTasksData>) =>
  queryOptions<
    GetTasksResponse,
    AxiosError<DefaultError>,
    GetTasksResponse,
    ReturnType<typeof getTasksQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTasks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTasksQueryKey(options),
  });

/**
 * Get all available tasks
 */
export const useGetTasksQuery = (options?: Options<GetTasksData>) =>
  useQuery(getTasksOptions(options));

/**
 * Create a user quest
 */
export const postQuestMutation = (
  options?: Partial<Options<PostQuestData>>
): UseMutationOptions<
  PostQuestResponse,
  AxiosError<DefaultError>,
  Options<PostQuestData>
> => {
  const mutationOptions: UseMutationOptions<
    PostQuestResponse,
    AxiosError<DefaultError>,
    Options<PostQuestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await postQuest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update a user quest
 */
export const putQuestMutation = (
  options?: Partial<Options<PutQuestData>>
): UseMutationOptions<
  PutQuestResponse,
  AxiosError<DefaultError>,
  Options<PutQuestData>
> => {
  const mutationOptions: UseMutationOptions<
    PutQuestResponse,
    AxiosError<DefaultError>,
    Options<PutQuestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await putQuest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getWrapped2025QueryKey = (options?: Options<GetWrapped2025Data>) =>
  createQueryKey("getWrapped2025", options);

/**
 * Get Palmetto Wrapped 2025 data for authenticated user
 */
export const getWrapped2025Options = (options?: Options<GetWrapped2025Data>) =>
  queryOptions<
    GetWrapped2025Response,
    AxiosError<DefaultError>,
    GetWrapped2025Response,
    ReturnType<typeof getWrapped2025QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWrapped2025({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWrapped2025QueryKey(options),
  });

/**
 * Get Palmetto Wrapped 2025 data for authenticated user
 */
export const useGetWrapped2025Query = (options?: Options<GetWrapped2025Data>) =>
  useQuery(getWrapped2025Options(options));

export const getOtpOptionsQueryKey = (options: Options<GetOtpOptionsData>) =>
  createQueryKey("getOtpOptions", options);

/**
 * Get OTP delivery options for a user
 */
export const getOtpOptionsOptions = (options: Options<GetOtpOptionsData>) =>
  queryOptions<
    GetOtpOptionsResponse,
    AxiosError<DefaultError>,
    GetOtpOptionsResponse,
    ReturnType<typeof getOtpOptionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOtpOptions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOtpOptionsQueryKey(options),
  });

/**
 * Get OTP delivery options for a user
 */
export const useGetOtpOptionsQuery = (options: Options<GetOtpOptionsData>) =>
  useQuery(getOtpOptionsOptions(options));

export const getUserQueryKey = (options: Options<GetUserData>) =>
  createQueryKey("getUser", options);

/**
 * Returns a user if one is available for logging in
 */
export const getUserOptions = (options: Options<GetUserData>) =>
  queryOptions<
    GetUserResponse,
    AxiosError<DefaultError>,
    GetUserResponse,
    ReturnType<typeof getUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUserQueryKey(options),
  });

/**
 * Returns a user if one is available for logging in
 */
export const useGetUserQuery = (options: Options<GetUserData>) =>
  useQuery(getUserOptions(options));

/**
 * Send OTP code to a user
 */
export const sendOtpMutation = (
  options?: Partial<Options<SendOtpData>>
): UseMutationOptions<
  SendOtpResponse,
  AxiosError<DefaultError>,
  Options<SendOtpData>
> => {
  const mutationOptions: UseMutationOptions<
    SendOtpResponse,
    AxiosError<DefaultError>,
    Options<SendOtpData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sendOtp({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Login with email/password or phone/password
 */
export const loginMutation = (
  options?: Partial<Options<LoginData>>
): UseMutationOptions<
  LoginResponse,
  AxiosError<DefaultError>,
  Options<LoginData>
> => {
  const mutationOptions: UseMutationOptions<
    LoginResponse,
    AxiosError<DefaultError>,
    Options<LoginData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await login({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Sign up with a signup token or OTP code
 */
export const signupMutation = (
  options?: Partial<Options<SignupData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<SignupData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<SignupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await signup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create OTP user and send OTP code
 */
export const sendOtp2Mutation = (
  options?: Partial<Options<SendOtp2Data>>
): UseMutationOptions<
  SendOtp2Response,
  AxiosError<DefaultError>,
  Options<SendOtp2Data>
> => {
  const mutationOptions: UseMutationOptions<
    SendOtp2Response,
    AxiosError<DefaultError>,
    Options<SendOtp2Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await sendOtp2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getAuthStatusQueryKey = (options?: Options<GetAuthStatusData>) =>
  createQueryKey("getAuthStatus", options);

/**
 * Check if the auth cookie is valid
 */
export const getAuthStatusOptions = (options?: Options<GetAuthStatusData>) =>
  queryOptions<
    GetAuthStatusResponse,
    AxiosError<DefaultError>,
    GetAuthStatusResponse,
    ReturnType<typeof getAuthStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAuthStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAuthStatusQueryKey(options),
  });

/**
 * Check if the auth cookie is valid
 */
export const useGetAuthStatusQuery = (options?: Options<GetAuthStatusData>) =>
  useQuery(getAuthStatusOptions(options));

/**
 * Clear the auth cookie
 */
export const authLogoutMutation = (
  options?: Partial<Options<AuthLogoutData>>
): UseMutationOptions<
  AuthLogoutResponse,
  AxiosError<DefaultError>,
  Options<AuthLogoutData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthLogoutResponse,
    AxiosError<DefaultError>,
    Options<AuthLogoutData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authLogout({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Generate a single-use token for auth exchange
 */
export const generateSutV2Mutation = (
  options?: Partial<Options<GenerateSutV2Data>>
): UseMutationOptions<
  GenerateSutV2Response,
  AxiosError<DefaultError>,
  Options<GenerateSutV2Data>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateSutV2Response,
    AxiosError<DefaultError>,
    Options<GenerateSutV2Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateSutV2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const exchangeSutForTokenV2QueryKey = (
  options: Options<ExchangeSutForTokenV2Data>
) => createQueryKey("exchangeSutForTokenV2", options);

/**
 * Exchange a SUT for an auth token
 */
export const exchangeSutForTokenV2Options = (
  options: Options<ExchangeSutForTokenV2Data>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof exchangeSutForTokenV2QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await exchangeSutForTokenV2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: exchangeSutForTokenV2QueryKey(options),
  });

/**
 * Exchange a SUT for an auth token
 */
export const useExchangeSutForTokenV2Query = (
  options: Options<ExchangeSutForTokenV2Data>
) => useQuery(exchangeSutForTokenV2Options(options));

/**
 * Search feed items owned by the authenticated user, or every feed item on one of their projects when projectId is provided
 */
export const searchFeedItemsMutation = (
  options?: Partial<Options<SearchFeedItemsData>>
): UseMutationOptions<
  SearchFeedItemsResponse,
  AxiosError<DefaultError>,
  Options<SearchFeedItemsData>
> => {
  const mutationOptions: UseMutationOptions<
    SearchFeedItemsResponse,
    AxiosError<DefaultError>,
    Options<SearchFeedItemsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await searchFeedItems({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update the status of a feed item owned by the authenticated user
 */
export const updateFeedItemStatusMutation = (
  options?: Partial<Options<UpdateFeedItemStatusData>>
): UseMutationOptions<
  UpdateFeedItemStatusResponse,
  AxiosError<DefaultError>,
  Options<UpdateFeedItemStatusData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateFeedItemStatusResponse,
    AxiosError<DefaultError>,
    Options<UpdateFeedItemStatusData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateFeedItemStatus({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getFinanceAccountsQueryKey = (
  options?: Options<GetFinanceAccountsData>
) => createQueryKey("getFinanceAccounts", options);

/**
 * Get all finance accounts for the authenticated user
 */
export const getFinanceAccountsOptions = (
  options?: Options<GetFinanceAccountsData>
) =>
  queryOptions<
    GetFinanceAccountsResponse,
    AxiosError<DefaultError>,
    GetFinanceAccountsResponse,
    ReturnType<typeof getFinanceAccountsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFinanceAccounts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFinanceAccountsQueryKey(options),
  });

/**
 * Get all finance accounts for the authenticated user
 */
export const useGetFinanceAccountsQuery = (
  options?: Options<GetFinanceAccountsData>
) => useQuery(getFinanceAccountsOptions(options));

export const getFinanceAccountQueryKey = (
  options: Options<GetFinanceAccountData>
) => createQueryKey("getFinanceAccount", options);

/**
 * Get finance account details
 */
export const getFinanceAccountOptions = (
  options: Options<GetFinanceAccountData>
) =>
  queryOptions<
    GetFinanceAccountResponse,
    AxiosError<DefaultError>,
    GetFinanceAccountResponse,
    ReturnType<typeof getFinanceAccountQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFinanceAccount({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFinanceAccountQueryKey(options),
  });

/**
 * Get finance account details
 */
export const useGetFinanceAccountQuery = (
  options: Options<GetFinanceAccountData>
) => useQuery(getFinanceAccountOptions(options));

export const getFinanceAccountDocumentQueryKey = (
  options: Options<GetFinanceAccountDocumentData>
) => createQueryKey("getFinanceAccountDocument", options);

/**
 * Stream finance account document
 */
export const getFinanceAccountDocumentOptions = (
  options: Options<GetFinanceAccountDocumentData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof getFinanceAccountDocumentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFinanceAccountDocument({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFinanceAccountDocumentQueryKey(options),
  });

/**
 * Stream finance account document
 */
export const useGetFinanceAccountDocumentQuery = (
  options: Options<GetFinanceAccountDocumentData>
) => useQuery(getFinanceAccountDocumentOptions(options));

export const getFinanceAccountDocumentsQueryKey = (
  options: Options<GetFinanceAccountDocumentsData>
) => createQueryKey("getFinanceAccountDocuments", options);

/**
 * Get finance account documents
 */
export const getFinanceAccountDocumentsOptions = (
  options: Options<GetFinanceAccountDocumentsData>
) =>
  queryOptions<
    GetFinanceAccountDocumentsResponse,
    AxiosError<DefaultError>,
    GetFinanceAccountDocumentsResponse,
    ReturnType<typeof getFinanceAccountDocumentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFinanceAccountDocuments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFinanceAccountDocumentsQueryKey(options),
  });

/**
 * Get finance account documents
 */
export const useGetFinanceAccountDocumentsQuery = (
  options: Options<GetFinanceAccountDocumentsData>
) => useQuery(getFinanceAccountDocumentsOptions(options));

/**
 * Submit a payment for a finance account
 */
export const postPaymentMutation = (
  options?: Partial<Options<PostPaymentData>>
): UseMutationOptions<
  PostPaymentResponse,
  AxiosError<DefaultError>,
  Options<PostPaymentData>
> => {
  const mutationOptions: UseMutationOptions<
    PostPaymentResponse,
    AxiosError<DefaultError>,
    Options<PostPaymentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await postPayment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Cancel a scheduled (pending) payment
 */
export const cancelPaymentMutation = (
  options?: Partial<Options<CancelPaymentData>>
): UseMutationOptions<
  CancelPaymentResponse,
  AxiosError<DefaultError>,
  Options<CancelPaymentData>
> => {
  const mutationOptions: UseMutationOptions<
    CancelPaymentResponse,
    AxiosError<DefaultError>,
    Options<CancelPaymentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await cancelPayment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPaymentMethodsQueryKey = (
  options: Options<GetPaymentMethodsData>
) => createQueryKey("getPaymentMethods", options);

/**
 * Get saved payment methods for a project or finance account
 */
export const getPaymentMethodsOptions = (
  options: Options<GetPaymentMethodsData>
) =>
  queryOptions<
    GetPaymentMethodsResponse,
    AxiosError<DefaultError>,
    GetPaymentMethodsResponse,
    ReturnType<typeof getPaymentMethodsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPaymentMethods({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPaymentMethodsQueryKey(options),
  });

/**
 * Get saved payment methods for a project or finance account
 */
export const useGetPaymentMethodsQuery = (
  options: Options<GetPaymentMethodsData>
) => useQuery(getPaymentMethodsOptions(options));

/**
 * Add a payment method for a project or finance account
 */
export const createPaymentMethodMutation = (
  options?: Partial<Options<CreatePaymentMethodData>>
): UseMutationOptions<
  CreatePaymentMethodResponse,
  AxiosError<DefaultError>,
  Options<CreatePaymentMethodData>
> => {
  const mutationOptions: UseMutationOptions<
    CreatePaymentMethodResponse,
    AxiosError<DefaultError>,
    Options<CreatePaymentMethodData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createPaymentMethod({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a saved payment method for a project or finance account
 */
export const deletePaymentMethodMutation = (
  options?: Partial<Options<DeletePaymentMethodData>>
): UseMutationOptions<
  DeletePaymentMethodResponse,
  AxiosError<DefaultError>,
  Options<DeletePaymentMethodData>
> => {
  const mutationOptions: UseMutationOptions<
    DeletePaymentMethodResponse,
    AxiosError<DefaultError>,
    Options<DeletePaymentMethodData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deletePaymentMethod({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set a payment method as the default (auto-pay) method, or update its nickname
 */
export const setDefaultPaymentMethodMutation = (
  options?: Partial<Options<SetDefaultPaymentMethodData>>
): UseMutationOptions<
  SetDefaultPaymentMethodResponse,
  AxiosError<DefaultError>,
  Options<SetDefaultPaymentMethodData>
> => {
  const mutationOptions: UseMutationOptions<
    SetDefaultPaymentMethodResponse,
    AxiosError<DefaultError>,
    Options<SetDefaultPaymentMethodData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await setDefaultPaymentMethod({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create a short-lived Plaid Link token for the authenticated user
 */
export const createPlaidLinkTokenMutation = (
  options?: Partial<Options<CreatePlaidLinkTokenData>>
): UseMutationOptions<
  CreatePlaidLinkTokenResponse,
  AxiosError<DefaultError>,
  Options<CreatePlaidLinkTokenData>
> => {
  const mutationOptions: UseMutationOptions<
    CreatePlaidLinkTokenResponse,
    AxiosError<DefaultError>,
    Options<CreatePlaidLinkTokenData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createPlaidLinkToken({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Exchange a Plaid public token and store the verified bank account as a payment method
 */
export const verifyPlaidAccountMutation = (
  options?: Partial<Options<VerifyPlaidAccountData>>
): UseMutationOptions<
  VerifyPlaidAccountResponse,
  AxiosError<DefaultError>,
  Options<VerifyPlaidAccountData>
> => {
  const mutationOptions: UseMutationOptions<
    VerifyPlaidAccountResponse,
    AxiosError<DefaultError>,
    Options<VerifyPlaidAccountData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await verifyPlaidAccount({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPointTransactionsQueryKey = (
  options?: Options<GetPointTransactionsData>
) => createQueryKey("getPointTransactions", options);

/**
 * Get paginated point transaction history for the authenticated user
 */
export const getPointTransactionsOptions = (
  options?: Options<GetPointTransactionsData>
) =>
  queryOptions<
    GetPointTransactionsResponse,
    AxiosError<DefaultError>,
    GetPointTransactionsResponse,
    ReturnType<typeof getPointTransactionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPointTransactions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPointTransactionsQueryKey(options),
  });

export const getPointTransactionsInfiniteQueryKey = (
  options?: Options<GetPointTransactionsData>
): QueryKey<Options<GetPointTransactionsData>> =>
  createQueryKey("getPointTransactions", options, true);

/**
 * Get paginated point transaction history for the authenticated user
 */
export const getPointTransactionsInfiniteOptions = (
  options?: Options<GetPointTransactionsData>
) =>
  infiniteQueryOptions<
    GetPointTransactionsResponse,
    AxiosError<DefaultError>,
    InfiniteData<GetPointTransactionsResponse>,
    QueryKey<Options<GetPointTransactionsData>>,
    | string
    | Pick<
        QueryKey<Options<GetPointTransactionsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetPointTransactionsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getPointTransactions({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getPointTransactionsInfiniteQueryKey(options),
    }
  );

/**
 * Get paginated point transaction history for the authenticated user
 */
export const useGetPointTransactionsQuery = (
  options?: Options<GetPointTransactionsData>
) => useQuery(getPointTransactionsOptions(options));

export const getUserFeedbackQueryKey = (
  options?: Options<GetUserFeedbackData>
) => createQueryKey("getUserFeedback", options);

/**
 * Get all feedback submitted by the authenticated user
 */
export const getUserFeedbackOptions = (
  options?: Options<GetUserFeedbackData>
) =>
  queryOptions<
    GetUserFeedbackResponse,
    AxiosError<DefaultError>,
    GetUserFeedbackResponse,
    ReturnType<typeof getUserFeedbackQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUserFeedback({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUserFeedbackQueryKey(options),
  });

/**
 * Get all feedback submitted by the authenticated user
 */
export const useGetUserFeedbackQuery = (
  options?: Options<GetUserFeedbackData>
) => useQuery(getUserFeedbackOptions(options));

/**
 * Submit feedback for a feature
 */
export const postUserFeedbackMutation = (
  options?: Partial<Options<PostUserFeedbackData>>
): UseMutationOptions<
  PostUserFeedbackResponse,
  AxiosError<DefaultError>,
  Options<PostUserFeedbackData>
> => {
  const mutationOptions: UseMutationOptions<
    PostUserFeedbackResponse,
    AxiosError<DefaultError>,
    Options<PostUserFeedbackData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await postUserFeedback({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create a new private media upload slot and get a signed upload URL
 */
export const createMediaMutation = (
  options?: Partial<Options<CreateMediaData>>
): UseMutationOptions<
  CreateMediaResponse2,
  AxiosError<DefaultError>,
  Options<CreateMediaData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateMediaResponse2,
    AxiosError<DefaultError>,
    Options<CreateMediaData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createMedia({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upload a file to private media storage
 */
export const uploadMediaMutation = (
  options?: Partial<Options<UploadMediaData>>
): UseMutationOptions<
  UploadMediaResponse2,
  AxiosError<DefaultError>,
  Options<UploadMediaData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadMediaResponse2,
    AxiosError<DefaultError>,
    Options<UploadMediaData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadMedia({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
